export default "__VITE_ASSET__BUzdG4_R__"